"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doctolibAccountingFileSchema = exports.MAX_DOCTOLIB_ACCOUNTING_SIZE = exports.getAccountingApiEntitySchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
exports.getAccountingApiEntitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('accountings'),
    attributes: zod_1.z.object({
        accountPeriod: zod_1.z.object({
            from: zod_1.z.coerce.string(),
            to: zod_1.z.coerce.string(),
        }),
        amountDue: zod_1.z.coerce.number(),
        amountPaid: zod_1.z.coerce.number(),
        amountPaidRetrocessionFee: zod_1.z.coerce.number(),
        amountMedicalAssistantFee: zod_1.z.coerce.number(),
        amountPayBack: zod_1.z.coerce.number(),
        medicalAssistantFee: zod_1.z.coerce.number(),
        paid: zod_1.z.coerce.boolean().default(false),
        doctolibImportId: zod_1.z.string().uuid().nullable().default(null),
        createdAt: zod_1.z.coerce.date(),
    }),
    relationships: zod_1.z
        .object({
        doctorSubstitute: (0, api_1.apiEntityRelationshipSchema)('doctor-substitutes').optional(),
        doctorAttending: (0, api_1.apiEntityRelationshipSchema)('doctor-attendings').optional(),
        office: (0, api_1.apiEntityRelationshipSchema)('offices').optional(),
        agendaSlots: (0, api_1.apiEntityRelationshipsSchema)('agenda-slots').optional(),
    })
        .optional()
        .default({}),
});
exports.MAX_DOCTOLIB_ACCOUNTING_SIZE = 10000000;
const ACCEPTED_DOCTOLIB_ACCOUNTING_TYPES = ['text/csv'];
exports.doctolibAccountingFileSchema = zod_1.z
    .any()
    .refine((file) => {
    return !!file;
}, 'form.errors.required')
    .refine((file) => {
    if (!file) {
        return false;
    }
    return ACCEPTED_DOCTOLIB_ACCOUNTING_TYPES.includes(file.type);
}, 'form.errors.doctolib-file-type')
    .refine((file) => {
    if (!file) {
        return false;
    }
    return file.size <= exports.MAX_DOCTOLIB_ACCOUNTING_SIZE;
}, 'form.errors.doctolib-max-size');
